import { IonBadge, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonImg, IonNote } from "@ionic/react";
import React from "react";
import { dateTime } from "../utils/format";
import { useViewport } from "../utils/useViewport";

const NewsItem: React.FC<{ item: any }> = (props: { item: any }) => {
  const { isMobile } = useViewport();

  return (
    <IonCard className="card card--news-item news-item" routerLink={`/news/${props.item.id}`}>
      {props.item.thumbnail_desktop ? <IonImg className="card__img" src={props.item["thumbnail_" + (isMobile ? "mobile" : "desktop")]} /> : ""}
      <IonCardHeader className="card__header">
        <IonCardTitle className="card__title text--secondary">
          <h2>{props.item.title}</h2>
          <IonBadge
            style={{
              marginTop: "6px",
              border: "1px solid " + props.item.category.colour,
              "--color": "#000",
              "--background": "#fff",
            }}
          >
            {props.item.category.name}
          </IonBadge>
          <IonNote className={"block"}>{dateTime(props.item.publish_at)}</IonNote>
        </IonCardTitle>
      </IonCardHeader>
      <IonCardContent className="card__content">{props.item.excerpt}</IonCardContent>
    </IonCard>
  );
};

export default NewsItem;
